import { Navigate } from 'react-router-dom'

import { Skeleton } from '@/components/feedback/Skeleton'
import { useSession } from '@/features/auth/api/useSession'
import { homeIsDashboard, homePathFor } from '@/lib/navigation'
import { DashboardPage } from '@/routes/DashboardPage'

/* "/" resolves by capability (S-2b.1; Story 1.4 resolved it by role).
 *
 * The dashboard is the home of whoever may read it — `finance.receivables.read`,
 * the capability its endpoint is guarded by. Everyone else starts on «Мои
 * задачи», the records waiting on them. `homePathFor` is the one rule; login's
 * landing (`DEFAULT_LANDING = '/'`) and the 404's way home both arrive here.
 *
 * A reader whose home IS the dashboard gets it rendered in place rather than
 * redirected to — "/" redirecting to "/" is a loop.
 */
export function HomeRoute() {
  const { data: user, isPending } = useSession()

  /* RequireSession has already established there is a session, but its data can
     still be in flight on a hard load. Redirecting on an absent user would send
     everyone to their tasks for a frame and then move them, so this waits. */
  if (isPending || !user) {
    return <Skeleton className="h-64 rounded-[var(--radius-DEFAULT)]" />
  }

  if (homeIsDashboard(user)) {
    return <DashboardPage />
  }

  // replace, so the back button leaves the application rather than returning to
  // a "/" that immediately bounces forward again.
  return <Navigate to={homePathFor(user)} replace />
}
